import apiClient from '../clienteFebosAPI';

const RESOURCE = '/v2/empresas';

export const ioCompanyGetAccessProfiles = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(`${RESOURCE}/${payload.empresaId}/perfiles?${params}`,
    { operacionId: 'io.empresas.get.access.profiles' });
};

export const ioGetRolesAccessProfiles = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(`${RESOURCE}/${payload.empresaId}/perfiles/${payload.perfilId}?${params}`,
    { operacionId: 'io.empresas.get.roles.profiles' });
};

export const ioAddRoleToAccessProfile = (payload) => (
  apiClient.post(
    `${RESOURCE}/${payload.empresaId}/perfiles/${payload.perfilId}/${payload.rolId}`,
    { operacionId: 'io.empresas.add.role.profile' }
  )
);

export const ioRemoveRoleToAccessProfile = (payload) => (
  apiClient.delete(
    `${RESOURCE}/${payload.empresaId}/perfiles/${payload.perfilId}/${payload.rolId}`,
    { operacionId: 'io.empresas.remove.role.profile' }
  )
);

export const ioAddAccessProfile = (payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient.post(`${RESOURCE}/${payload.empresaId}/perfiles?${params}`, payload,
    { operacionId: 'io.empresas.add.profile' });
};

export const ioEditAccessProfile = (payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient.put(`${RESOURCE}/${payload.empresaId}/perfiles/${payload.perfilId}?${params}`,
    payload,
    { operacionId: 'io.empresas.edit.profile' });
};

export const ioGetUserProfiles = (payload) => (
  apiClient.get(
    `${RESOURCE}/${payload.empresaId}/usuarios/${payload.usuarioId}/perfiles`,
    { operacionId: 'io.empresas.get.user.profiles' }
  )
);

export const ioAddProfileToUser = (payload) => (
  apiClient.post(
    `${RESOURCE}/${payload.empresaId}/usuarios/${payload.usuarioId}/perfiles/${payload.perfilId}`,
    { operacionId: 'io.empresas.add.profile.user' }
  )
);

export const ioRemoveProfileToUser = (payload) => (
  apiClient.delete(
    `${RESOURCE}/${payload.empresaId}/usuarios/${payload.usuarioId}/perfiles/${payload.perfilId}`,
    { operacionId: 'io.empresas.remove.profile.user' }
  )
);

export const ioRemoveProfile = (payload) => (
  apiClient.delete(
    `${RESOURCE}/${payload.empresaId}/perfiles/${payload.perfilId}`,
    { operacionId: 'io.empresas.remove.profile' }
  )
);

export const ioMigrateProfile = ({ companyId, profileId, environments }) => (
  apiClient.post(
    `${RESOURCE}/${companyId}/perfiles/${profileId}/migrar`,
    { destinos: environments },
    { operacionId: 'io.empresas.profile.migrate' }
  )
);

export const ioCopyProfilesByUser = ({
  companyId, userId, targetUsersIds, reemplazar
}) => apiClient.post(
  `${RESOURCE}/${companyId}/usuarios/${userId}/perfiles/copiar`,
  { destinos: targetUsersIds, reemplazar },
  { operacionId: 'io.empresas.profile.copy' }
);

export const ioGetHoldingCompanies = ({ empresaId, params }) => {
  const requestParams = apiClient.queryParams(params);
  return apiClient.get(
    `${RESOURCE}/${empresaId}/holding?${requestParams}`,
    { operacionId: 'io.get.companies.holding' }
  );
};

export const ioGetHoldingGroupsCompanies = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(`${RESOURCE}/${payload.empresaId}/holding/grupos?${params}`,
    { operacionId: 'io.empresas.get.holding.groups' });
};

export const ioCompanyUsersReport = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(`${RESOURCE}/${payload.empresaId}/usuarios/reporte?${params}`,
    { operacionId: 'io.empresa.usuarios.reporte' });
};

export const ioGetUsersProfile = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(`${RESOURCE}/${payload.empresaId}/perfiles/${payload.perfilId}/usuarios?${params}`,
    { operacionId: 'io.empresa.usuarios.perfil' });
};

export const ioUsersReport = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.post(
    `${RESOURCE}/${payload.empresaId}/reportes/usuarios?${params}`,
    payload.body,
    { operacionId: 'io.empresa.reporte.usuarios' }
  );
};

export const ioProfileReport = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.post(
    `${RESOURCE}/${payload.empresaId}/reportes/perfiles?${params}`,
    payload.body,
    { operacionId: 'io.empresa.reporte.perfil' }
  );
};

export const ioCreateMassiveUsers = (payload) => apiClient.post(
  `${RESOURCE}/${payload.empresaId}/usuarios/masivos`,
  { urlAdjunto: payload.file },
  { operacionId: 'io.empresa.masivo.usuarios' }
);
